import React, { FC } from 'react';
import { PeriodicBillingListGrid } from './grids';

const PeriodicPostpaidBillingList: FC<{ isSensitiveDataIsShown?: boolean }> = ({ isSensitiveDataIsShown }) => {
  return <PeriodicBillingListGrid isSensitiveDataIsShown={isSensitiveDataIsShown} />;
};

export default PeriodicPostpaidBillingList;
